
export const getCourseNameInArmenian = (courseValue: string): string => {
  const courseTranslations: Record<string, string> = {
    'web-programming': '\u054E\u0565\u0562 \u056E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574',
    'ai': '\u0531\u0580\u0570\u0565\u057D\u057F\u0561\u056F\u0561\u0576 \u0532\u0561\u0576\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576',
    'aicourse': '\u0531\u0580\u0570\u0565\u057D\u057F\u0561\u056F\u0561\u0576 \u0532\u0561\u0576\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576',
    'cybersecurity': '\u053F\u056B\u0562\u0565\u057C\u0561\u0576\u057E\u057F\u0561\u0576\u0563\u0578\u0582\u0569\u0575\u0578\u0582\u0576',
    'kids-programming': '\u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574 \u0565\u0580\u0565\u056D\u0561\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580 (15+)',
    'ai-teacher-training': 'AI-\u056B \u056F\u056B\u0580\u0561\u057C\u0578\u0582\u0574\u0568 \u0584\u0561\u0575\u056C \u0561\u057C \u0584\u0561\u0575\u056C (3 \u0585\u0580)'
  };
  return courseTranslations[courseValue] || courseValue;
};

export const getLearningTypeInArmenian = (typeValue: string): string => {
  const typeTranslations: Record<string, string> = {
    'individual': '\u0531\u0576\u0570\u0561\u057F\u0561\u056F\u0561\u0576',
    'group': '\u053D\u0574\u0562\u0561\u0575\u056B\u0576'
  };
  return typeTranslations[typeValue] || typeValue;
};

export const getLearningFormatInArmenian = (formatValue: string): string => {
  const formatTranslations: Record<string, string> = {
    'online': '\u0555\u0576\u056C\u0561\u0575\u0576',
    'inPerson': '\u0531\u057C\u056F\u0561'
  };
  return formatTranslations[formatValue] || formatValue;
};

export const getDurationInArmenian = (durationValue: string): string => {
  const durationTranslations: Record<string, string> = {
    '6': '\u0532\u0561\u0566\u0561\u0575\u056B\u0576 6 \u0561\u0574\u056B\u057D',
    '9': '\u0546\u0561\u056D\u0561\u0566\u0578\u0580\u0561\u056F\u0578\u0579\u0561\u0575\u056B\u0576 9 \u0561\u0574\u056B\u057D',
    '18': '\u0531\u056F\u0561\u0564\u0565\u0574\u056B\u0561\u056F\u0561\u0576 18 \u0561\u0574\u056B\u057D'
  };
  return durationTranslations[durationValue] || durationValue;
};